var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-image",class:{ 'fake-image': !_vm.isRealImage },style:(_vm.styleWH)},[_c('img',{ref:"imgEle",staticClass:"pic",attrs:{"src":_vm.formatPath,"crossorigin":"anonymous"},on:{"load":_vm.onLoad,"click":_vm.viewImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }